import { createFileRoute } from '@tanstack/react-router';

/**
 * Renders nothing: the layout owns what `/app/settings` shows. On a phone that
 * is the section rail on its own, so the index has to be a real (empty) route
 * rather than a redirect to the first pane — a redirect would drop you into a
 * section you never picked. Wide screens are sent to the first pane from the
 * layout instead, where the viewport is known.
 */
export const Route = createFileRoute(
  '/app/_authenticated/_dashboard/settings/',
)({
  component: () => null,
});
